import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar';

// Scrolls to top on route change and shows a top loading bar.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const ref = useRef(null);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    if (ref.current) {
      ref.current.continuousStart();
      setTimeout(() => ref.current?.complete(), 300);
    }
  }, [pathname]);

  return (
    <LoadingBar
      color="var(--primary)"
      ref={ref}
      height={3}
      shadow={true}
    />
  );
};

export default ScrollToTop;